import React from 'react'

import { MultiLine as Component } from './component'
// 
const MultiLine = (props) => {
  return <Component {...props}/>
}
export default MultiLine
